import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RecaptchaModule } from 'ng-recaptcha';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeroComponent } from './sections/hero/hero.component';
import { BenefitsComponent } from './sections/benefits/benefits.component';
import { FeaturesComponent } from './sections/features/features.component';
import { HowItWorksComponent } from './sections/how-it-works/how-it-works.component';
import { AudienceComponent } from './sections/audience/audience.component';
import { PricingComponent } from './sections/pricing/pricing.component';
import { FaqComponent } from './sections/faq/faq.component';
import { FinalCtaComponent } from './sections/final-cta/final-cta.component';
import { SiteFooterComponent } from './sections/site-footer/site-footer.component';

@NgModule({
  declarations: [
    AppComponent,
    HeroComponent,
    BenefitsComponent,
    FeaturesComponent,
    HowItWorksComponent,
    AudienceComponent,
    PricingComponent,
    FaqComponent,
    FinalCtaComponent,
    SiteFooterComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    RecaptchaModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
